import React from 'react';

export const AlertIcon = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
    style={{
      fillRule: 'evenodd',
    }}
    {...props}
  >
    <path d="M10.619,4.527 C10.967,3.877 12.032,3.877 12.381,4.527 L12.381,4.527 L19.881,18.527 C20.048,18.84 20.04,19.209 19.857,19.514 C19.675,19.818 19.355,20 19,20 L19,20 L4.001,20 C3.646,20 3.325,19.818 3.143,19.514 C2.96,19.209 2.952,18.84 3.12,18.527 L3.12,18.527 L10.618,4.527 Z M11.5,5 L4.001,19 L19,19 L11.5,5 Z M12,16 L12,17 L11,17 L11,16 L12,16 Z M12,10 L12,15 L11,15 L11,10 L12,10 Z"></path>
  </svg>
);
